import { FormEvent, useEffect, useState } from "react";
import { EncryptionService } from "../../services/EncryptionService";
import { getContractsUrl } from "../../config";
import useAPI from "../../Hooks/useAPI";
import { useUser } from "../../Context/UserContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import sent from "../../Pages/Sent/Sent.module.css";
import Header from "../Header2/Header2";
import Footer from "../Footer/FooterSmall";

export interface UserData {
  source: string;
  company: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  title: string;
  id: string;
  entityId: string;
  streetaddress: string;
  streetaddress2: string;
  city: string;
  state: string;
  zip: string;
  contractAdmin: boolean;
}
interface ReDirecteContractProps {
  dest: string;
}
const ReDirecteContract: React.FC<ReDirecteContractProps> = ({ dest }) => {
  const { user, setUser, hasPermission } = useUser();
  const [isReady, setIsReady] = useState(false);
  const { addUserTracking } = useAPI();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const doccode = searchParams.get("doccode");
  const doctype = searchParams.get("doctype");
  if (doccode) {
    sessionStorage.setItem("doccode", doccode);
  }
  if (doctype) {
    sessionStorage.setItem("doctype", doctype);
  }

  // if (!user) {
  //     return <div>User does not have permission</div>;
  // }

  useEffect(() => {
    // Redirect if not admin
    console.log(window.location.href);
    if (!user) {
      navigate("/");
      return;
    }
    if (dest === "ContractsDashboard" && !hasPermission("admin_contracts")) {
      navigate("/");
      return;
    }
  }, [user?.roles, navigate]);

  const [encryptionService] = useState(() => new EncryptionService());

  const encryptField = (value: string): string => {
    return encryptionService.encryptField(value);
  };

  useEffect(() => {
    const loadKey = async () => {
      try {
        await encryptionService.loadPublicKey();
        setIsReady(true);
      } catch (err) {
        console.error("Failed to load public key:", err);
      }
    };
    loadKey();
  }, [encryptionService]);

  useEffect(() => {
    if (!isReady || !user) return;

    const contractsUrl = getContractsUrl();

    if (!encryptionService.getPublicKey()) {
      alert("Public key not loaded");
      return;
    }

    const encryptedParams = (
      Object.keys(updatedUserData) as (keyof UserData)[]
    ).map(
      (key) =>
        `${fieldMap[key]}=${encodeURIComponent(
          encryptField(updatedUserData[key]),
        )}`,
    );

    const sessDocCode = sessionStorage.getItem("doccode");
    const sessDocType = sessionStorage.getItem("doctype");
    if (sessDocCode) {
      encryptedParams.push(`o=${encodeURIComponent(sessDocCode)}`);
      sessionStorage.removeItem("doccode");
    }

    if (sessDocType) {
      encryptedParams.push(`p=${encodeURIComponent(sessDocType)}`);
      sessionStorage.removeItem("doctype");
    }

    const finalUrl = `${contractsUrl}/${dest}/?${encryptedParams.join("&")}`;

    console.log(finalUrl);
    window.location.href = finalUrl;
  }, [isReady, user]); // runs once key + user are ready

  if (!user) return null;

  const updatedUserData = {
    source: "Contracts<32Gem$",
    company: String(user.companyName), //check if has it?
    firstName: String(user.firstName),
    lastName: String(user.lastName),
    phone: String(user.phone), //check if has it?
    email: String(user.email),
    title: String(user.title),
    id: String(user.id),
    entityId: String(user.entityid),
    streetaddress: String(user.streetaddress),
    streetaddress2: String(user.streetaddress2),
    city: String(user.city),
    state: String(user.state),
    zip: String(user.zip),
    contractAdmin: String(hasPermission("admin_contracts")),
  };

  const fieldMap: Record<keyof UserData, string> = {
    source: "r",
    company: "a",
    firstName: "b",
    lastName: "c",
    phone: "d",
    email: "e",
    title: "f",
    id: "g",
    entityId: "i",
    contractAdmin: "j",
    streetaddress: "k",
    city: "l",
    state: "m",
    zip: "n",
    streetaddress2: "q",
  };

  // const loadkey = async () => {
  //     const apiUrl = getContractsUrl();
  //     if (!encryptionService.getPublicKey()) {
  //         alert("Public key not loaded");
  //         return null;
  //     }

  //     const encryptedParams = (Object.keys(updatedUserData) as (keyof UserData)[]).map(
  //         key => `${fieldMap[key]}=${encodeURIComponent(encryptField(updatedUserData[key]))}`
  //     );
  //     const finalUrl = `${apiUrl}/?${encryptedParams.join("&")}`;
  //     console.log(finalUrl);
  //     window.location.href = finalUrl;
  // }
  // loadkey();

  return (
    <div className="generalPage">
      <div className="landingPage">
        <Header />
        <div className={sent.sentBody}>
          <h2>You are being redirected</h2>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ReDirecteContract;
